import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { AngularMaterialModule } from '@app/shared/modules/angular-material.module';
import { DynamicPipe } from '@app/shared/pipes/dynamic-pipe';
import { CommonFieldName } from '@app/shared/constants';
import { BasedComponent } from '@shared/components/based.component';
import { ImportResultErrorMessageTranslate } from '@app/shared/pipes/import-result-error-message-translate';

@Component({
  selector: 'app-import-data-result-data-grid-cell',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AngularMaterialModule, CommonModule, TranslateModule, DynamicPipe, ImportResultErrorMessageTranslate],
  template: `
  @if(data[field] === ''){
    <div></div>
  }
  @else {
    @switch (field) {
      @case (commonFieldName.translationId){
        <div [innerHtml]="data[field] | importResultErrorMessageTranslate: data"></div>
      }
      @default {
        <div [innerHtml]="data[field] | dynamicPipe: column.pipe: column.pipeArgs"></div>
      }
    }
  }
  `
})
export class ImportDataResultDataGridCell extends BasedComponent {
  commonFieldName = CommonFieldName;

  @Input() data: any;
  @Input() field: string;
  @Input() column: any;
}
